<!--时间表对象 右键属性-->
<template>
  <div>
    <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? name + '-时间表' : name + '' + '时间表'" :has-form="true" class="time-event-dialog-modal" top="15%"
      width="36%" @close="close" @confirm="handleConfirm">
      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="常规" name="first">
          <gs-form :model="form" label-width="50px" label-position="left" gap="small">
            <gs-form-item label="名称" prop="target" class="form-item-radio">
              <gs-input ref="nameInput" v-model="name" @change="timeCharTitle" />
            </gs-form-item>
            <gs-form-item label="描述" prop="target" class="form-item-radio">
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="description">
              </el-input>
            </gs-form-item>
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane label="时间规划" name="second">
          <div class="border-main">
            <div class="seventy-part">
              <!-- 时间表格 -->
            </div>
            <div class="thirty-part">
              <!--<fieldset>
                <legend>时间表</legend>
                <datePicker
                  :year="year"
                  :month="month"
                  @changeDate="changeDate"
                  @preMon="preMon"
                  @nextMon="nextMon"
                />
              </fieldset>-->
              <!-- <legend>时间段</legend>-->
              <!--<gs-input
                  v-model="num"
                  style="width:100px;"
                />
                <gs-select
                  v-model="logSpace_unit"
                  class="doc-select"
                  style="width:100px"
                >
                  <gs-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :disabled="item.disabled"
                    :value="item.value"
                  />
                </gs-select>-->
              <!--<gs-table
                  ref = 'selectionTable'
                  :data="timeChartList"
                  @selection-change="getSelections"
                  @row-click="handleRowClick"
                >
                  <gs-table-column
                    type="selection"
                  />
                  &lt;!&ndash;<gs-table-column
                    prop="formDate"
                    label="开始日期"
                  />
                  <gs-table-column
                    prop="toDate"
                    label="结束日期"
                  />&ndash;&gt;
                  <gs-table-column
                    prop="startTime"
                    label="开始时间"
                  />
                  <gs-table-column
                    prop="stopTime"
                    label="结束时间"
                  />
                  <gs-table-column
                    prop="weekDays"
                    label="星期"
                  />
                </gs-table>-->
              <!--<fieldset  >
                <legend>创建</legend>
               &lt;!&ndash; <gs-button
                  class="event-btn"
                  @click="newAddShow"
                >新建</gs-button>
                <gs-button
                  class="event-btn"
                  @click="openAddEvent"
                >所有事件</gs-button>&ndash;&gt;
                <gs-form :model="form">
                    <div style="padding:10px">
                      <gs-radio-group v-model="timeType">
                        <gs-radio :label="1">指定时间段</gs-radio>
                        <gs-radio :label="2">全天开启</gs-radio>
                      </gs-radio-group>
                    </div>
                    <gs-time-picker
                      :disabled="timeType!==1"
                      v-model="formDatas.startTime"
                      format="HH:mm"
                      @change="compareValue"
                    />
                    <gs-time-picker
                      :disabled="timeType!==1"
                      v-model="formDatas.stopTime"
                      format="HH:mm"
                      @change="compareValue"
                    />
                    <gs-checkbox
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      class="custom-label"
                      @change="handleCheckAllChange"
                    >全选</gs-checkbox>
                    <gs-checkbox-group
                      v-model="checkedCities"
                      @change="handleCheckedCitiesChange"
                    >
                      <gs-checkbox
                        v-for="city in cities"
                        :label="city"
                        :key="city"
                        style="margin:10px"
                      >{{ city }}</gs-checkbox>
                    </gs-checkbox-group>
                </gs-form>
                <el-collapse v-model="activeNameOne" accordion>
                  <el-collapse-item title="展开时间范围" name="1">
                    <div>10:28-10:28</div>
                  </el-collapse-item>
                </el-collapse>
                <div style="float: right"><el-button size="mini" @click="handleConfirmData">创建</el-button></div>
              </fieldset>-->
              <!--<el-tabs type="border-card">
                <el-tab-pane>
                  <span slot="label"><i class="el-icon-date"></i> 时间规划1</span>
                    &lt;!&ndash; <gs-button
                       class="event-btn"
                       @click="newAddShow"
                     >新建</gs-button>
                     <gs-button
                       class="event-btn"
                       @click="openAddEvent"
                     >所有事件</gs-button>&ndash;&gt;
                    <gs-form :model="form">
                      <gs-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="checkAll"
                        class="custom-label"
                        @change="handleCheckAllChange"
                      >全选</gs-checkbox>
                      <gs-checkbox-group
                        v-model="checkedCities"
                        @change="handleCheckedCitiesChange"
                      >
                        <gs-checkbox
                          v-for="city in cities"
                          :label="city"
                          :key="city"
                          style="margin:10px"
                        >{{ city }}</gs-checkbox>
                      </gs-checkbox-group>
                       <div style="padding:10px">
                            <gs-radio-group v-model="timeType">
                              <gs-radio :label="1">指定时间段</gs-radio>
                              <gs-radio :label="2">全天开启</gs-radio>
                            </gs-radio-group>
                         </div>
                       <gs-time-picker
                        :disabled="timeType!==1"
                        v-model="formDatas.startTime"
                        format="HH:mm"
                        @change="compareValue"
                      />
                       <gs-time-picker
                        :disabled="timeType!==1"
                        v-model="formDatas.stopTime"
                        format="HH:mm"
                        @change="compareValue"
                      />
                       <el-button size="mini" @click="handleConfirmData">创建</el-button>
                       <el-table
                            :data="timeChartList"
                            style="width: 100%">
                            <el-table-column
                              prop="startTime"
                              label="开始时间"
                              align="center"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="stopTime"
                              label="结束时间"
                              align="center"
                            >
                            </el-table-column>
                          </el-table>
                    </gs-form>
                </el-tab-pane>
                <el-tab-pane>
                  <span slot="label"><i class="el-icon-date"></i> 时间规划2</span>
                  &lt;!&ndash; <gs-button
                     class="event-btn"
                     @click="newAddShow"
                   >新建</gs-button>
                   <gs-button
                     class="event-btn"
                     @click="openAddEvent"
                   >所有事件</gs-button>&ndash;&gt;
                  <gs-form :model="form">
                    <gs-checkbox
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      class="custom-label"
                      @change="handleCheckAllChange"
                    >全选</gs-checkbox>
                    <gs-checkbox-group
                      v-model="checkedCities"
                      @change="handleCheckedCitiesChange"
                    >
                      <gs-checkbox
                        v-for="city in cities"
                        :label="city"
                        :key="city"
                        style="margin:10px"
                      >{{ city }}</gs-checkbox>
                    </gs-checkbox-group>
                    <el-collapse v-model="activeNameOne" accordion>
                      <el-collapse-item title="展开时间范围" name="1">
                        <div style="padding:10px">
                          <gs-radio-group v-model="timeType">
                            <gs-radio :label="1">指定时间段</gs-radio>
                            <gs-radio :label="2">全天开启</gs-radio>
                          </gs-radio-group>
                        </div>
                        <gs-time-picker
                          :disabled="timeType!==1"
                          v-model="formDatas.startTime"
                          format="HH:mm"
                          @change="compareValue"
                        />
                        <gs-time-picker
                          :disabled="timeType!==1"
                          v-model="formDatas.stopTime"
                          format="HH:mm"
                          @change="compareValue"
                        />
                        <el-button size="mini" @click="handleConfirmData">创建</el-button>
                      </el-collapse-item>
                    </el-collapse>
                  </gs-form>
                </el-tab-pane>
                <el-tab-pane>
                  <span slot="label"><i class="el-icon-date"></i> 时间规划3</span>
                  &lt;!&ndash; <gs-button
                     class="event-btn"
                     @click="newAddShow"
                   >新建</gs-button>
                   <gs-button
                     class="event-btn"
                     @click="openAddEvent"
                   >所有事件</gs-button>&ndash;&gt;
                  <gs-form :model="form">
                    <gs-checkbox
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      class="custom-label"
                      @change="handleCheckAllChange"
                    >全选</gs-checkbox>
                    <gs-checkbox-group
                      v-model="checkedCities"
                      @change="handleCheckedCitiesChange"
                    >
                      <gs-checkbox
                        v-for="city in cities"
                        :label="city"
                        :key="city"
                        style="margin:10px"
                      >{{ city }}</gs-checkbox>
                    </gs-checkbox-group>
                    <el-collapse v-model="activeNameOne" accordion>
                      <el-collapse-item title="展开时间范围" name="1">
                        <div style="padding:10px">
                          <gs-radio-group v-model="timeType">
                            <gs-radio :label="1">指定时间段</gs-radio>
                            <gs-radio :label="2">全天开启</gs-radio>
                          </gs-radio-group>
                        </div>
                        <gs-time-picker
                          :disabled="timeType!==1"
                          v-model="formDatas.startTime"
                          format="HH:mm"
                          @change="compareValue"
                        />
                        <gs-time-picker
                          :disabled="timeType!==1"
                          v-model="formDatas.stopTime"
                          format="HH:mm"
                          @change="compareValue"
                        />
                        <el-button size="mini" @click="handleConfirmData">创建</el-button>
                      </el-collapse-item>
                    </el-collapse>
                  </gs-form>
                </el-tab-pane>
              </el-tabs>-->
              <gs-form :model="form">
                <!--<gs-checkbox
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      class="custom-label"
                      @change="handleCheckAllChange"
                    >全选</gs-checkbox>-->
                <gs-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                  <gs-checkbox v-for="city in cities" :label="city" :key="city" style="margin:10px">{{ city
                    }}</gs-checkbox>
                </gs-checkbox-group>
                <div style="padding:10px;float: left">
                  <!-- <gs-radio-group v-model="timeType">
                    <gs-radio :label="1">指定时间段</gs-radio>
                  </gs-radio-group> -->
                </div>
                <div style="margin-top: 8px;margin-left: 15px;display: flex;align-items: center;">
                  <span style="font-size: 12px">开始时间：</span>
                  <gs-time-picker :disabled="timeType !== 1" v-model="formDatas.startTime" format="HH:mm"
                    @change="compareValue" />
                  <!-- <div
                    style="width: 100px;"
                    class="inp"
                  >
                    <gs-input></gs-input>
                  </div> -->

                  <span style="font-size: 12px;margin-left: 15px">结束时间：</span>
                  <gs-time-picker :disabled="timeType !== 1" v-model="formDatas.stopTime" format="HH:mm"
                    @change="compareValue" />
                  <!-- <div
                    style="width: 100px;"
                    class="c"
                  >
                    <gs-input></gs-input>
                  </div> -->
                  <!-- <gs-button
                    size="mini"
                    style="margin-left:15px"
                    @click="handleConfirmData"
                  >&nbsp;&nbsp;&nbsp;创建&nbsp;&nbsp;&nbsp;</gs-button> -->
                  <div style="float: right;margin-top: 2px;margin-left: 20px;">
                    <span style="color: #ff7f00;cursor: pointer;" @click="handleConfirmData">创建</span>
                  </div>

                </div>

                <el-table size='mini' :data="timeChartList"
                  :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #343434' }"
                  style="width: 100%;margin-top:15px" @cell-dblclick="rableEdit">
                  <el-table-column prop="startTime" label="开始时间" align="center">
                  </el-table-column>
                  <el-table-column prop="stopTime" label="结束时间" align="center">
                    <template slot-scope="scope">
                      <gs-time-picker v-if="scope.row.stopShow" :disabled="timeType !== 1" v-model="formDatas.stopTime"
                        format="HH:mm" @change="compareValue" />
                      <span v-else>{{ scope.row.stopTime }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                      <i class="el-icon-s-tools" @click="updateTime(scope)"></i>
                      <i style="margin-left:20px" class="el-icon-delete-solid" @click="delTime(scope)"></i>
                    </template>
                  </el-table-column>
                </el-table>
              </gs-form>
            </div>
          </div>
        </gs-tab-pane>
        <gs-tab-pane label="联动数据" name="last">
          <div class="top-form-right">
            <gs-form label-width="100px" label-position="left" gap="small">
            </gs-form>
          </div>
          <div>
            <span @click="add" style='color:#ff7f00;cursor: pointer;'>对象列表</span>
            <div class="form-item-objectSeries">
              <el-table :data="objectSeries" size="mini"
                :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #4e4c4c' }"
                style="width: 100%" height="220">
                <el-table-column prop="name" label="名称" align="center">
                </el-table-column>
                <el-table-column prop="type" label="类型" align="center">
                </el-table-column>
                <el-table-column label="开始值" align="center">
                  <template slot-scope="scope">

                    <gs-input style="margin-top: 0px;margin-bottom:0px" v-show="true" v-model="scope.row.startnum" />

                  </template>
                </el-table-column>
                <el-table-column label="结束值" align="center">
                  <template slot-scope="scope">

                    <gs-input v-show="true" v-model="scope.row.stopnum" />

                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <i class="el-icon-delete-solid" @click="delObjectData(scope)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- <div class="bottom-btn">
              <gs-button @click="add">添加</gs-button>
              <gs-button @click="dell">删除</gs-button>
            </div> -->
          </div>
        </gs-tab-pane>
      </gs-tabs>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
        <!-- <gs-button type="primary" size="mini">帮 助</gs-button> -->
      </span>
    </gs-modal>
    <gs-modal v-loading="loadingData" v-model="visibleData" :before-close="beforeCloseData"
      :title="isEdit ? '编辑' : '新建'" class="my-test-class" @close="closeData" @confirm="handleConfirmData">
      <gs-form :model="form">
        <fieldset>
          <legend>范围</legend>
          <div style="padding:10px">
            <gs-checkbox v-model="formDatas.isWeek">每周</gs-checkbox>
            <!-- <gs-checkbox
              :disabled="formDatas.isWeek"
              v-model="formDatas.isYear"
            >每年</gs-checkbox>-->
          </div>
          <!-- <gs-date-picker
            v-model="formDatas.date"
            :disabled="formDatas.isWeek"
            :default-time="[formDatas.defaultTime, formDatas.defaultTime1]"
            style="padding:10px"
            type="date-range"
          />-->
        </fieldset>
        <fieldset>
          <legend>时间</legend>
          <div style="padding:10px">
            <gs-radio-group v-model="timeType">
              <gs-radio :label="1">指定时间段</gs-radio>
              <gs-radio :label="3" :disabled="formDatas.isWeek">全天关闭</gs-radio>
            </gs-radio-group>
          </div>
          <gs-time-picker :disabled="timeType !== 1" v-model="formDatas.startTime" format="HH:mm"
            @change="compareValue" />
          <gs-time-picker :disabled="timeType !== 1" v-model="formDatas.stopTime" format="HH:mm"
            @change="compareValue" />
        </fieldset>

        <fieldset>
          <legend>有效日</legend>
          <gs-checkbox :indeterminate="isIndeterminate" v-model="checkAll" class="custom-label"
            @change="handleCheckAllChange">全选</gs-checkbox>
          <gs-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
            <gs-checkbox v-for="city in cities" :label="city" :key="city" style="margin:10px">{{ city }}</gs-checkbox>
          </gs-checkbox-group>
        </fieldset>
      </gs-form>
    </gs-modal>
    <gs-modal v-model="visibleAll" :before-close="beforeCloseAll" :title="'所有事件'" class="my-test-class"
      @close="closeAll" @confirm="handleConfirmAll">
      <fieldset>
        <legend>所有事件</legend>
        <gs-table ref='selectionTable' :data="timeChartList" @selection-change="getSelections"
          @row-click="handleRowClick">
          <gs-table-column type="selection" />
          <gs-table-column prop="formDate" label="开始日期" />
          <gs-table-column prop="toDate" label="结束日期" />
          <gs-table-column prop="startTime" label="开始时间" />
          <gs-table-column prop="stopTime" label="结束时间" />
          <gs-table-column prop="weekDays" label="星期" />
        </gs-table>
        <!-- <gs-pagination
          ref="pagination"
          :current="currentPage"
          :total="parseInt(tableList.length/5)+1"
          :before-jump="page => beforeJump(page, 'pagination')"
          style="margin-top:20px;"
          layout="simplepager,jumper,jumpbtn"
        /> -->
        <div>
          <gs-button @click="openNewAdd">新建</gs-button>
          <gs-button @click="edit">编辑</gs-button>
          <gs-button @click="del">删除</gs-button>
        </div>
      </fieldset>
    </gs-modal>
    <gs-modal v-model="visibleAdd" :before-close="beforeCloseAdd" class="my-test-class" title="添加" @close="closeAdd"
      @confirm="handleConfirmAdd">
      <gs-tree v-if="visibleAdd" ref="tree" :data="addList" :props="props" :disable-node="true"
        :leaf-checkbox-only="true" :node-key="'id'" show-checkbox @check-change="checkEvent" />
    </gs-modal>
    <gs-modal title="时间段修改" v-model="dialogHelp" class="time-event-dialog-modal" :before-close="handleCloseHelp"
      @confirm="handleConfirmUpdateTime">
      <gs-form :model="form" label-width="95px" label-position="left" gap="small">
        <gs-form-item label="开始时间" prop="target" class="form-item-radio">
          <gs-time-picker v-model="startTime" format="HH:mm" @change="compareValue" />
        </gs-form-item>
        <gs-form-item label="结束时间" prop="target" class="form-item-radio">
          <gs-time-picker v-model="stopTime" format="HH:mm" @change="compareValue" />
        </gs-form-item>
      </gs-form>
    </gs-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
import datePicker from '../datePicker/dayPicker'
import exchangeTime from '../../utils/timeExchange.js'
import newAdd from './timeChartNewAdd'
import eventBus from './vue.js'
import allEvent from './allEvent'
import moment from 'moment'
export default {
  components: {
    datePicker, newAdd, allEvent
  },
  data() {
    return {
      startTime: moment(),
      stopTime: moment(),
      timeChartsUpdate: false,
      addData: false,
      editableTabsValue: '2',
      editableTabs: [{
        title: '时间规划',
        name: '1',
        content: 'Tab 1 content'
      }],
      tabIndex: 2,  // tab切换
      activeNameOne: '0',
      dialogHelp: false,
      logSpace_unit: 'm',
      options: [{
        label: '分(m)',
        value: 'm'
      }, {
        label: '时(h)',
        value: 'h'
      }, {
        label: '天(d)',
        value: 'd'
      }
      ],
      num: 1,
      objectSeries: [],
      showList: [],
      row: '',
      oldData: {},
      props: {
        label: 'name',
        disabled: 'type:folder'
      },
      addList: [],
      visibleAdd: false,
      selectList: [],
      //列表
      visibleAll: false,
      tableList: [],
      radio: {},
      editData: {},
      currentPage: 1,
      multipleSelection: [],
      selection: [],
      select: false, //选择单个数据
      //主
      isEdit: false,
      loading: false,
      activeName: 'first',
      form: {
        checked: '',
        checked1: '',
        min1: '',
        min2: '',
        max1: '',
        max2: '',
        objList: [],
        time: '',
        select: '',
        maxNum: '',
      },
      description: '',
      name: '',
      checked: '',
      tableData: [],
      year: '',
      month: '',
      today: '',
      addShow: false,
      addEventShow: false,
      timeChartList: [],
      eventsList: [],
      //新建
      visibleData: false,
      loadingData: false,
      checkAll: true,
      checkedCities: ['星期一', '星期二', '星期三', '星期四', '星期五'],
      cities: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
      isIndeterminate: true,
      timeType: 1,
      formDatas: {
        triggerCron: '',
        isWeek: true,
        date: '',
        isYear: false,
        date1: '',
        formDate: moment(),
        toDate: moment(),
        startTime: moment(),
        stopTime: moment()
      },
      timeCharteIndex: '',
    }
  },
  computed: {
    ...mapState({
      visible: 'timeChartShow',
      nodeData: 'nodeTree',
      objectData: 'objectInfo'
    })
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData
    },
    visible() {
      if (this.visible) {
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        this.activeName = 'first'
        if (JSON.stringify(this.objectData) !== '{}' && this.objectData.type === 'timeChart') {
          debugger
          this.addData = true
          this.form = this.objectData.attribute ? this.objectData.attribute : {}
          this.description = this.objectData.description
          this.name = this.objectData.name
          // this.name = this.nodeData.name
          this.isEdit = true
          this.eventsList = this.objectData.attribute.events
          this.timeChartList = this.objectData.attribute.events
          this.objectSeries = this.objectData.attribute.objectSeries
          this.objectData.attribute.jobGroupName = this.nodeData.name
          this.eventsList.forEach(e => {
            if (!e.id) {
              e.id = Math.random()
            }
          })
        } else {
          this.form = {}
          this.description = ''
          this.name = ''
          this.isEdit = false
          this.eventsList = []
          this.timeChartList = []
          this.objectSeries = []
        }
      } else {
        this.addData = false
        this.form = {}
        this.description = ''
        this.name = ''
        this.isEdit = false
        this.eventsList = []
        eventBus.$emit('reSetList', true)
      }
    }
  },
  created() {
    this.timeChartList = []
    this.year = parseInt(exchangeTime(new Date()).substr(0, 4))
    this.month = parseInt(exchangeTime(new Date()).substr(5, 2))
  },
  mounted() {
    this.timeChartList = []
    eventBus.$on('openNewAdd', () => {
      this.addShow = true
    })
  },
  methods: {
    ...mapMutations({
      close: 'TIME_CHART_HIDE'
    }),
    delObjectData(val) {
      this.objectSeries.splice(val.$index, 1);
    },
    beforeCloseTimeUpdate() {
      this.timeChartsUpdate = false
    },
    handleConfirmUpdateTime() {
      this.timeChartList[this.timeCharteIndex].startTime = moment(this.startTime).format('HH:mm')
      this.timeChartList[this.timeCharteIndex].stopTime = moment(this.stopTime).format('HH:mm')
      this.dialogHelp = false
    },
    rableEdit(row, column) {
      if (column.label === "结束时间") {
        row.stopShow = !row.stopShow;
      }
    },
    updateTime(val) {
      this.timeCharteIndex = val.$index
      this.dialogHelp = true
      this.startTime = val.startTime
      this.stopTime = val.stopTime
    },
    delTime(val) {
      this.timeChartList.splice(val.$index, 1);
    },
    // 时间表名称同步
    timeCharTitle() {

    },
    handleChange(val) {
      console.log(val);
    },
    onChangeCron(val) {
      this.formDatas.triggerCron = val
    },
    handleConfirmAdd() {
      let _this = this
      this.$refs.tree.getCheckedNodes(true).forEach(e => {
        _this.objectSeries.push(e.data)
      })
      this.objectSeries = this.unique(this.objectSeries, 'id')
      this.visibleAdd = false
    },
    unique(arr, name) {
      var hash = {}
      return arr.reduce(function (item, next) {
        hash[next[name]] ? '' : hash[next[name]] = true && item.push(next)
        return item
      }, [])
    },
    closeAdd() {
      this.visibleAdd = false
    },
    beforeCloseAdd() {
      this.visibleAdd = false
    },
    checkEvent(node, isSelect, halfSelect) {
      // value_Analog,
      // value_Multistate,
      // value_Binary,
      // value_String,
      // BinaryInput,
      // BinaryOutput,
      // AnalogInput,
      // AnalogOutput
      /* switch (node.type) {
        case 'value_Analog':

          break
        case 'value_Multistate':

          break
        case 'value_Binary':

          break
        case 'value_String':

          break
        case 'BinaryInput':

          break
        case 'BinaryOutput':

          break
        case 'AnalogInput':

          break
        case 'AnalogOutput':

          break

        default:
          this.$Message.error('此节点为目录，无法被选择')
          this.$refs.tree.setChecked(node.id, false)
          break
      } */
    },
    add() {
      let _this = this
      if (this.addData) {
        this.$Message.warning('无法添加点位')
      } else {
        service.getTree('Point', _this.objectData.id).then(res => {
          console.log(res)
          this.addList = res
          if (_this.form.objectSeries !== null && _this.form.objectSeries.length > 0) {
            setTimeout(() => {
              _this.form.objectSeries.forEach(res => {
                _this.$refs.tree.setChecked(res.id, true)
              })
            }, 0)
          }
        })
        this.visibleAdd = true
      }
    },
    dell() {
      if (this.selectList === null || this.selectList.length === 0) {
        this.$Message.warning('请至少选择一项')
        return
      }
      this.selectList.forEach((value, index, array) => {
        this.objectSeries = this.objectSeries.filter(e => {
          return e.id !== value.id
        })
      })
    },
    selectData(selection, row) {
      this.selectList = selection
    },
    //列表
    beforeCloseAll() {
      this.visibleAll = false
    },
    closeAll() {
      this.visibleAll = false
    },
    handleConfirmAll() {
      this.eventsList = this.selection
      this.visibleAll = false
      this.select = true
    },
    getSelections(selection) {
      if (selection.length > 1) {
        this.$refs.selectionTable.clearSelection()
        this.$refs.selectionTable.toggleRowSelection(selection.pop())
      } else {
        this.selection = selection
      }
    },
    handleRowClick(row, column, event) {
      this.$refs.selectionTable.toggleRowSelection(row)
    },
    openNewAdd() {
      this.visibleData = true
    },
    del() {
      // 每秒计算
      let arr = this.timeChartList
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === this.selection[0].id) {
          arr.splice(i, 1)
        }
      }
    },
    edit() {
      if (!this.radio) {

      } else {

      }
      this.editData = this.radio
      this.visibleData = true
      if (this.editData.formDate.indexOf('*') === 0) {
        this.editData.formDate = new Date().getFullYear() + this.editData.formDate.substr(4, 6)
      }
      if (this.editData.toDate.indexOf('*') === 0) {
        this.editData.toDate = new Date().getFullYear() + this.editData.toDate.substr(4, 6)
      }
      if (this.editData.formDate === '-') {
        this.editData.formDate = moment(new Date()).format('YYYY-MM-DD')
      }
      if (this.editData.toDate === '-') {
        this.editData.toDate = moment(new Date()).format('YYYY-MM-DD')
      }
      eventBus.$emit('editTimeChart', this.editData)
    },
    //主
    beforeClose() {
      this.objectSeries = []
      this.addList = []
      this.select = false
      this.close()
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm() {
      // 生成cron表达式
      let _this = this
      let days = []
      let cornStartArray = []
      let cornStoptArray = []
      this.checkedCities.forEach(e => {
        switch (e) {
          case '星期一':
            days[0] = '2'
            break
          case '星期二':
            days[1] = '3'
            break
          case '星期三':
            days[2] = '4'
            break
          case '星期四':
            days[3] = '5'
            break
          case '星期五':
            days[4] = '6'
            break
          case '星期六':
            days[5] = '7'
            break
          case '星期日':
            days[6] = '1'
            break
          default:
            break
        }
      })
      days = days.join(',')
      //this.loading = true
      this.timeChartList.forEach(e => {
        delete e.id
        // 开始时间分隔生成corn表达式
        let arrayStart = e.startTime.split(":")
        let flipArrStart = arrayStart.reverse()
        let numberArrStart = flipArrStart.map(Number)
        let stringJoinStart = numberArrStart.join(" ")
        let cornStart = `0 ${stringJoinStart} ? * ${days}`
        cornStartArray.push(cornStart)
        // 结束时间
        let arrayStop = e.stopTime.split(":")
        let flipArrStop = arrayStop.reverse()
        let numberArrStop = flipArrStop.map(Number)
        let stringJoinStop = numberArrStop.join(" ")
        let cornStop = `0 ${stringJoinStop} ? * ${days}`
        cornStoptArray.push(cornStop)
      })
      console.log(cornStoptArray)
      // 生成cron数组
      let cron = []
      for (let i = 0; i < cornStartArray.length; i++) {
        let cornData = {}
        let cornArr = {}
        this.objectSeries.forEach(e => {
          // 
          cornData[e.id] = e.startnum
          /* let cronData = {}
          let keyCron = cornStartArray[i]
          let value = {}
          let keyid = e.id
          let startValue = e.startnum
          value[keyid] = startValue
          cronData[keyCron] = value
          cron.push(cronData) */
        })
        cornArr[cornStartArray[i]] = cornData
        cron.push(cornArr)
      }
      for (let i = 0; i < cornStoptArray.length; i++) {
        let cornData = {}
        let cornArr = {}
        this.objectSeries.forEach(e => {
          cornData[e.id] = e.stopnum
          /* let cronData = {}
          let keyCron = cornStoptArray[i]
          let value = {}
          let keyid = e.id
          let stopValue = e.stopnum
          value[keyid] = stopValue
          cronData[keyCron] = value
          cron.push(cronData) */
        })
        cornArr[cornStoptArray[i]] = cornData
        cron.push(cornArr)
      }
      if (this.objectData.id && this.objectData.type === 'timeChart') {
        let param = {
          id: this.objectData.id,
          'name': this.name,
          'type': 'timeChart',
          value: this.objectData.value,
          'parentId': this.objectData.parentId,
          'description': this.description,
          'attribute': {
            'objectSeries': this.objectSeries,
            "deviceGroupId": this.objectData.parentId,
            "cron": cron,
            "jobGroupName": this.nodeData.name,
            "jobName": 1,
            timeInterval: this.num,
            logSpace_unit: this.logSpace_unit,
            events: this.timeChartList
          } // 其他信息这里，键值对形式
        }
        service.renamePoint(param).then(res => {
          this.loading = false
          this.$notify.success({
            message: '修改成功',
            offset: 24,
            showClose: false,
            duration: '1000'
          });
          this.close()
        }).catch(err => {
          this.loading = false
          this.$Message.error(err.message)
        })
      } else {
        let param = {}
        if (this.select) {
          if (this.selection.length === 0) {
            let arr = this.timeChartList[0].weekDays.split("")
            this.timeChartList[0].weekDays = arr
            param = {
              'name': this.name,
              'type': 'timeChart',
              'parentId': this.objectData.id,
              'description': this.description,
              'attribute': {
                'objectSeries': this.objectSeries,
                'timeChartList': this.timeChartList,
                "deviceGroupId": this.objectData.parentId,
                "cron": cron,
                "jobGroupName": this.nodeData.name,
                "jobName": 1,
                timeInterval: this.num,
                logSpace_unit: this.logSpace_unit,
                events: this.timeChartList,
                toValue: this.objectSeries,
              } // 其他信息这里，键值对形式
            }
          } else {
            let arr = this.timeChartList[0].weekDays.split("")
            this.timeChartList[0].weekDays = arr
            param = {
              'name': this.name,
              'type': 'timeChart',
              'parentId': this.objectData.id,
              'description': this.description,
              'attribute': {
                'objectSeries': this.objectSeries,
                'timeChartList': this.timeChartList,
                "deviceGroupId": this.objectData.parentId,
                "cron": cron,
                "jobGroupName": this.nodeData.name,
                "jobName": 1,
                timeInterval: this.num,
                logSpace_unit: this.logSpace_unit,
                events: this.selection,
                toValue: this.objectSeries
              } // 其他信息这里，键值对形式
            }
          }
        } else {
          //   let arr =  this.timeChartList[0].weekDays.split("")
          //   this.timeChartList[0].weekDays = arr
          param = {
            'name': this.name,
            'type': 'timeChart',
            'parentId': this.objectData.id,
            'description': this.description,
            'attribute': {
              'objectSeries': this.objectSeries,
              "deviceGroupId": this.objectData.parentId,
              "cron": cron,
              "jobGroupName": this.nodeData.name,
              "jobName": 1,
              timeInterval: this.num,
              logSpace_unit: this.logSpace_unit,
              events: this.timeChartList,
              toValue: this.objectSeries   // 这里是点位数值
            } // 其他信息这里，键值对形式
          }
        }
        // 判断是否为设备组
        if (this.objectData.type === 'deviceGroup') {
          param.attribute.deviceGroupId = this.nodeData.id
        }
        this.select = false
        console.log(param, "9999999999")
        service.newAddPoint(param).then(res => {
          this.loading = false
          this.$notify.success({
            message: '添加成功',
            offset: 24,
            showClose: false,
            duration: '1000'
          });
          _this.objectSeries = []
          _this.timeChartList = []
          this.close()
        }).catch(err => {
          this.loading = false
          this.$Message.error(err.message)
        })
      }
      this.select = false

    },
    newAddShow() {
      // this.addShow = true
      this.visibleData = true
    },
    closeNewAdd(data) {
      this.addShow = false
      this.timeChartList = data
      this.eventsList = data
    },
    openAddEvent() {
      //this.addEventShow = true
      this.visibleAll = true
    },
    closeAllEvent() {
      this.addEventShow = false
    },
    changeDate(changeDate) {

    },
    preMon() {
      if (this.month === 1) {
        this.month = 12
        this.year--
      } else {
        this.month--
      }
    },
    nextMon() {
      if (this.month === 12) {
        this.month = 1
        this.year++
      } else {
        this.month++
      }
    },
    // 新建
    closeData() {
      this.form = {
        isWeek: true,
        date: '',
        isYear: false
      }
      this.isEdit = false
      this.checkedCities = []
      this.visibleData = false
    },
    handleConfirmData() {
      this.formDatas.formDate = this.formDatas.date[0]
      this.formDatas.toDate = this.formDatas.date[1]
      let textString = ['_', '_', '_', '_', '_', '_', '_']
      this.checkedCities.forEach(e => {
        switch (e) {
          case '星期一':
            textString[0] = 'M'
            break
          case '星期二':
            textString[1] = 'T'
            break
          case '星期三':
            textString[2] = 'W'
            break
          case '星期四':
            textString[3] = 'T'
            break
          case '星期五':
            textString[4] = 'F'
            break
          case '星期六':
            textString[5] = 'S'
            break
          case '星期日':
            textString[6] = 'S'
            break
          default:
            break
        }
      })
      textString = textString.join('')
      if (this.formDatas.id) {
        for (let i = 0; i < this.timeChartList.length; i++) {
          if (this.timeChartList[i].id === this.formDatas.id) {
            // delete e
            this.timeChartList.splice(i, 1)
            let from = ''
            let to = ''
            let startTime = ''
            let endTime = ''
            if (this.formDatas.isYear && !this.formDatas.isWeek) {
              from = '****-' + moment(this.formDatas.formDate).format('YYYY-MM-DD').substr(5, 10)
              to = '****-' + moment(this.formDatas.toDate).format('YYYY-MM-DD').substr(5, 10)
            } else if (this.formDatas.isWeek) {
              from = '-'
              to = '-'
            } else {
              from = moment(this.formDatas.formDate).format('YYYY-MM-DD')
              to = moment(this.formDatas.toDate).format('YYYY-MM-DD')
            }
            switch (this.timeType) {
              case 1:
                startTime = moment(this.formDatas.startTime).format('HH:mm')
                endTime = moment(this.formDatas.stopTime).format('HH:mm')
                break
              case 2:
                startTime = '00:00'
                endTime = '24:00'
                break
              case 3:
                startTime = '00:00'
                endTime = '00:00'
                break
              default:
                break
            }
            let period = ''
            if (this.formDatas.isWeek && !this.formDatas.isYear) {
              period = 'week'
            } else if (!this.formDatas.isWeek && this.formDatas.isYear) {
              period = 'year'
            } else {
              period = 'day'
            }

            this.timeChartList.push({
              stopShow: false,
              startShow: false,
              id: this.formDatas.id,
              formDate: from,
              toDate: to,
              startTime: startTime,
              stopTime: endTime,
              weekDays: textString,
              isTime: this.timeType,
              period: period
            })
          }
        }
      } else {
        let from = ''
        let to = ''
        let startTime = ''
        let endTime = ''
        if (this.formDatas.isYear && !this.formDatas.isWeek) {
          from = '****-' + moment(this.formDatas.formDate).format('YYYY-MM-DD').substr(5, 10)
          to = '****-' + moment(this.formDatas.toDate).format('YYYY-MM-DD').substr(5, 10)
        } else if (this.formDatas.isWeek) {
          from = '-'
          to = '-'
        } else {
          from = moment(this.formDatas.formDate).format('YYYY-MM-DD')
          to = moment(this.formDatas.toDate).format('YYYY-MM-DD')
        }
        switch (this.timeType) {
          case 1:
            startTime = moment(this.formDatas.startTime).format('HH:mm')
            endTime = moment(this.formDatas.stopTime).format('HH:mm')
            break
          case 2:
            startTime = '00:00'
            endTime = '24:00'
            break
          case 3:
            startTime = '00:00'
            endTime = '00:00'
            break
          default:
            break
        }
        let period = ''
        if (this.formDatas.isWeek && !this.formDatas.isYear) {
          period = 'week'
        } else if (!this.formDatas.isWeek && this.formDatas.isYear) {
          period = 'year'
        } else {
          period = 'day'
        }
        this.timeChartList.push({
          id: 'id' + moment().format('HH:mm:ss'),
          formDate: from,
          toDate: to,
          startTime: startTime,
          stopTime: endTime,
          weekDays: textString,
          isTime: this.timeType,
          period: period
        })
      }
      this.eventsList = this.timeChartList
      console.log(this.eventsList)
      this.visibleData = false
    },
    compareValue() {
      if (this.form.startTime && this.form.stopTime) {
        let start = moment(this.form.startTime)
        let end = moment(this.form.stopTime)
        let startHour = start.hour()
        let endHour = end.hour()
        let startMin = start.minute()
        let endMin = end.minute()
        let finalstart = startHour * 60 * 60 + startMin * 60
        let finalend = endHour * 60 * 60 + endMin * 60
        if (finalstart > finalend) {
          this.$Message.error('您选择的时间有误')
          this.form.startTime = moment()
          this.form.stopTime = moment()
          return false
        }
      }
    },
    handleCheckAllChange(event) {
      this.checkedCities = event.target.checked ? timeOptions : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount > 0
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length
    },
    beforeCloseData() {
      this.visibleData = false
    },
    handleCloseHelp() {
      this.dialogHelp = false
    }
  }
}
</script>
<style>
/* .gs-form-item {
  margin-bottom: 0px !important;
} */
</style>
<style scoped>
.inp>>>.gs-input,
.gs-input-number {
  height: 26px;
}

.gs-modal-wrap {
  top: 11%;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 45%;
  float: left;
  margin-right: 20px;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.seventy-part {
  box-sizing: border-box;
  float: left;
  width: 65%;
}

.thirty-part {
  box-sizing: border-box;
  float: left;
  width: 100%;
}

.event-btn {
  margin: 10px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 47%;
  float: left;
  margin-right: 13px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.form-item-objectSeries {
  height: 250px;
  overflow: auto;
  margin-bottom: 12px;
  padding: 12px;
  border: solid 1px #d9d9d9;
  border-radius: 1px;
}

.form-item-objectSeries>>>.gs-form-item {
  margin-bottom: 0px m !important;
}
</style>



// WEBPACK FOOTER //
// src/components/timeChart/timeChart.vue